export class DebrisTypeEquipement {
    id: number;
    type: string;

    public constructor(init?: Partial<DebrisTypeEquipement>) {
      Object.assign(this, init);
    }
  }
